import { viewPermissionRefs } from './components/UserGroupPermissions';
import { REPORT_KEYS } from '../views/analytics/models';

interface NavItem {
  to: string;
  label: string;
  permissionRef: string;
  icon?: string;
  subItems?: NavItem[];
}

const getSideMenuUrl = (baseUrl: string, relativeUrl: string) => {
  const fullUrl = `${baseUrl}/${relativeUrl}`;
  return baseUrl ? fullUrl : '/';
};

export const getSideMenuItems = (baseUrl: string): NavItem[] => {
  return [
    {
      to: getSideMenuUrl(baseUrl, 'overview'),
      icon: 'uil-estate',
      label: 'overview',
      permissionRef: viewPermissionRefs.site,
    },
    {
      to: getSideMenuUrl(baseUrl, 'tasks'),
      icon: 'uil-file-check-alt',
      label: 'tasks',
      permissionRef: viewPermissionRefs.task,
      subItems: [
        {
          to: getSideMenuUrl(baseUrl, 'tasks'),
          label: 'daily',
          permissionRef: viewPermissionRefs.task,
        },
        {
          to: getSideMenuUrl(baseUrl, 'tasks/maintenance'),
          label: 'maintenance',
          permissionRef: viewPermissionRefs.view_maintenance_page,
        },
        {
          to: getSideMenuUrl(baseUrl, 'tasks/work-orders'),
          label: 'workOrders',
          permissionRef: viewPermissionRefs.task,
        },
        {
          to: getSideMenuUrl(baseUrl, 'tasks/admin'),
          label: 'admin',
          permissionRef: viewPermissionRefs.settings,
        },
      ],
    },
    {
      to: getSideMenuUrl(baseUrl, 'tasks-v2'),
      icon: 'uil-file-check-alt',
      label: 'tasksV2',
      permissionRef: viewPermissionRefs.task,
      subItems: [
        {
          to: getSideMenuUrl(baseUrl, 'tasks-v2'),
          label: 'daily',
          permissionRef: viewPermissionRefs.task,
        },
        {
          to: getSideMenuUrl(baseUrl, 'tasks-v2/maintenance'),
          label: 'maintenance',
          permissionRef: viewPermissionRefs.view_maintenance_page,
        },
        {
          to: getSideMenuUrl(baseUrl, 'tasks-v2/work-orders'),
          label: 'workOrders',
          permissionRef: viewPermissionRefs.task,
        },
        {
          to: getSideMenuUrl(baseUrl, 'tasks-v2/admin'),
          label: 'admin',
          permissionRef: viewPermissionRefs.settings,
        },
      ],
    },
    {
      to: getSideMenuUrl(baseUrl, 'detergents'),
      icon: 'uil-water-glass',
      label: 'detergents',
      permissionRef: viewPermissionRefs.detergent,
    },
    {
      to: getSideMenuUrl(baseUrl, 'washcounts'),
      icon: 'uil-chart-pie',
      label: 'washCounts',
      permissionRef: viewPermissionRefs.wash_count,
    },
    {
      to: getSideMenuUrl(baseUrl, 'claims-old'),
      icon: 'uil-exclamation-triangle',
      label: 'claimsOld',
      permissionRef: viewPermissionRefs.warranty,
      subItems: [
        {
          to: getSideMenuUrl(baseUrl, 'claims-old'),
          label: 'claims',
          permissionRef: viewPermissionRefs.warranty,
        },
        {
          to: getSideMenuUrl(baseUrl, 'claims-old/reports'),
          label: 'reports',
          permissionRef: viewPermissionRefs.warranty,
        },
        {
          to: getSideMenuUrl(baseUrl, 'claims-old/damage-options'),
          label: 'damageOptions',
          permissionRef: viewPermissionRefs.damage,
        },
      ],
    },
    {
      to: getSideMenuUrl(baseUrl, 'claims'),
      icon: 'uil-exclamation-triangle',
      label: 'claimsV2',
      permissionRef: viewPermissionRefs.warranty,
      subItems: [
        {
          to: getSideMenuUrl(baseUrl, 'claims'),
          label: 'claims',
          permissionRef: viewPermissionRefs.warranty,
        },
        {
          to: getSideMenuUrl(baseUrl, 'claims/reports'),
          label: 'reports',
          permissionRef: viewPermissionRefs.warranty,
        },
        {
          to: getSideMenuUrl(baseUrl, 'claims/damage-options'),
          label: 'damageOptions',
          permissionRef: viewPermissionRefs.damage,
        },
      ],
    },
    {
      to: getSideMenuUrl(baseUrl, 'rewashes'),
      icon: 'uil-raindrops-alt',
      label: 'rewashes',
      permissionRef: viewPermissionRefs.rewash,
    },
    {
      to: getSideMenuUrl(baseUrl, 'purchases'),
      icon: 'uil-usd-square',
      label: 'purchases',
      permissionRef: viewPermissionRefs.expense,
    },
    {
      to: getSideMenuUrl(baseUrl, 'utilities'),
      icon: 'uil-dashboard',
      label: 'utilities',
      permissionRef: viewPermissionRefs.expense,
    },
    {
      to: getSideMenuUrl(baseUrl, 'inventory'),
      icon: 'uil-archive-alt',
      label: 'inventory',
      permissionRef: viewPermissionRefs.inventory,
      subItems: [
        {
          to: getSideMenuUrl(baseUrl, 'inventory'),
          label: 'inventory',
          permissionRef: viewPermissionRefs.inventory,
        },
        {
          to: getSideMenuUrl(baseUrl, 'inventory/types'),
          label: 'types',
          permissionRef: viewPermissionRefs.inventory,
        },
        {
          to: getSideMenuUrl(baseUrl, 'inventory/my-assets'),
          label: 'myAssets',
          permissionRef: viewPermissionRefs.view_assets_page,
        },
        {
          to: getSideMenuUrl(baseUrl, 'inventory/site-assets'),
          label: 'siteAssets',
          permissionRef: viewPermissionRefs.view_assets_page,
        },
      ],
    },
    {
      to: getSideMenuUrl(baseUrl, 'analytics'),
      icon: 'uil-chart',
      label: 'analytics',
      permissionRef: viewPermissionRefs.analytics,
      subItems: Object.keys(REPORT_KEYS).map((key) => ({
        to: getSideMenuUrl(baseUrl, `analytics/${key.toLowerCase()}`),
        label: `analytics${key}`,
        permissionRef: viewPermissionRefs.analytics,
      })),
    },
    {
      to: getSideMenuUrl(baseUrl, 'settings'),
      icon: 'uil-cog',
      label: 'settings',
      permissionRef: viewPermissionRefs.settings,
    },
  ];
};
